import { AxiosError, AxiosResponse } from "axios";

import { ALLOWANCE_API_ENDPOINTS } from "@/features/allowance/api/endpointsAllowance";
import apiRequests from "@/shared/config/axiosConfig";

type DeleteAllowanceResponse = {
  message: string;
  statusCode: number;
};

export default async function deleteAllowance(
  allowanceId: string
): Promise<DeleteAllowanceResponse> {
  try {
    const url = ALLOWANCE_API_ENDPOINTS.DELETE_ALLOWANCE.replace(
      "{allowanceId}",
      allowanceId
    );

    const response: AxiosResponse<DeleteAllowanceResponse> =
      await apiRequests.delete(url);

    const { data, status } = response;

    if (status >= 200 && status < 300) {
      return data;
    }

    throw new Error(`Unknown error occurred with status code ${response.status}`);
  } catch (e) {
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
